import { manifest as deleteKindManifest } from './delete.action.kind.js';

export const manifests = [deleteKindManifest];
